import React from 'react';
import { makeStyles } from '@material-ui/styles';

import Logo from '../assets/images/logo.png';

const useStyle = makeStyles({
  code: {
    fontSize: 100
  },
  divider: {
    margin: '20px 0'
  }
});

const Code400 = () => {
  const classes = useStyle();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <div className={classes.divider} />
      <img src={Logo} alt="Logo" />
      <div className={classes.divider} />
      <span className={classes.code}>400</span>
      <p>Oops, page does not exist.</p>
      <p></p>
    </div>
  );
};

export default Code400;
